/* eslint-disable no-undef */
import axios from 'axios'
import { store } from '../redux/store'
import { setButtonLoading, setIsRequesting } from '../redux/actions'

const instance = axios.create({
  baseURL: window.location.hostname === 'localhost' ? 'http://localhost:8080/dev' : 'https://api-prod-client.reescrever.app/',
  timeout: 30000,
  headers: {
    'Content-Type': 'application/json'
  }
})

instance.interceptors.request.use(
  async (config) => {
    config.headers.common.Authorization = localStorage.getItem('user-token')
    store.dispatch(setIsRequesting(true))
    return config
  },
  () => { }
)

instance.interceptors.response.use(
  (response) => {
    store.dispatch(setIsRequesting(false))
    store.dispatch(setButtonLoading(false))
    return response
  },
  (error) => {
    store.dispatch(setIsRequesting(false))
    store.dispatch(setButtonLoading(false))
    return Promise.reject(error)
  }
)

export default instance
